var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#1C3C54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6825 22.34C29.6825 26.0075 27.02 29.4425 23.3825 30.4475C23.135 30.515 22.865 30.515 22.6175 30.4475C18.98 29.4425 16.3175 26.0075 16.3175 22.34V19.0475C16.3175 18.4325 16.7825 17.735 17.36 17.5025L21.5375 15.7925C22.475 15.41 23.5325 15.41 24.47 15.7925L28.6475 17.5025C29.2175 17.735 29.69 18.4325 29.69 19.0475L29.6825 22.34Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.375C23.3978 23.375 23.7794 23.217 24.0607 22.9357C24.342 22.6544 24.5 22.2728 24.5 21.875C24.5 21.4772 24.342 21.0956 24.0607 20.8143C23.7794 20.533 23.3978 20.375 23 20.375C22.6022 20.375 22.2206 20.533 21.9393 20.8143C21.658 21.0956 21.5 21.4772 21.5 21.875C21.5 22.2728 21.658 22.6544 21.9393 22.9357C22.2206 23.217 22.6022 23.375 23 23.375ZM23 23.375V25.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#1C3C54",
    strokeOpacity: 0.6,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.ee029d0936f4172c4d75b681d9e666a3.svg";
export { ForwardRef as ReactComponent };